module.exports = __webpack_public_path__ + "static/media/suspension_channel_long.79be1ac0.webp";